window.nfpConfig = {
    baseUrl : "",
    network: null,
    walletConnect : {
        infuraId: "ac09d5abb9154f3ba86442116998be8f",
    },
    chains: {
        "0x1": {
            network: "MainNet", name: "Ethereum", networkId: 1, aggregator: {
                enabled: true,
                address: '0x7985e6ac13799ca1a31007f54c115f5b68c6aa3f',
                contractName: 'UpgradeAggregator'
            }, default: true
        },
        "0x89": {
            network: "Polygon", name: "Polygon", networkId: 137, aggregator: {
                enabled: true,
                address: '0xd8cb20164b2212f3cf9d82e940d936a1e3eb05bf',
                contractName: 'UpgradeAggregator'
            }, default: false
        },
    },
    contracts: {
        list: {
            "0x92133e21fff525b16d1edcf78be82297d25d1154": {
                name: "NFP",
                image: "https://nftcdn.daz3d.com/nfp/gen1/i/",
                thumb: "https://nftcdn.daz3d.com/nfp/gen1/t/",
                init: true,
            },
            "0xc3c31782cfac9563ba65f332bbe3100020ad81b6": {
                name: "Daz Generic Upgrade",
                tokens: {
                    1: {
                        name: "Diamond Hands",
                        image: "https://nftcdn.daz3d.com/nfp/upgrades/diamondhands/potion.png",
                        thumb: "https://nftcdn.daz3d.com/nfp/upgrades/diamondhands/potion.png"
                    },
                    2: {
                        name: "Louis Moinet Space Revolution Watch",
                        image: "https://nftcdn.daz3d.com/nfp/upgrades/lm/watch.jpg",
                        thumb: "https://nftcdn.daz3d.com/nfp/upgrades/lm/watch.jpg"
                    },
                },
                init: false,
            },
            "0xfed364dd70217782b01971d6c3993d99663ec239": {
                name: "Champion x NFP",
                types: {
                    1: {
                        name: "Champion x NFP - Bronze",
                        image: "https://nftcdn.daz3d.com/nfp/champion/gen1/bronze_revealed.png",
                        thumb: "https://nftcdn.daz3d.com/nfp/champion/gen1/bronze_revealed.png",
                    },
                    2: {
                        name: "Champion x NFP - Silver",
                        image: "https://nftcdn.daz3d.com/nfp/champion/gen1/silver_revealed.png",
                        thumb: "https://nftcdn.daz3d.com/nfp/champion/gen1/silver_revealed.png",
                    },
                    3: {
                        name: "Champion x NFP - Gold",
                        image: "https://nftcdn.daz3d.com/nfp/champion/gen1/gold_revealed.png",
                        thumb: "https://nftcdn.daz3d.com/nfp/champion/gen1/gold_revealed.png",
                    },
                },
                init: false,
            },
            "0x0bb2053ea7621fa6324641aee6ce856a0b9f8595": {
                name: "Clinique",
                tokens: {
                    1: {
                        name: "Clinique - Pastel Pop",
                        image: "https://nftcdn.daz3d.com/nfp/upgrades/clinique/1.png",
                        thumb: "https://nftcdn.daz3d.com/nfp/upgrades/clinique/1.png",
                    },
                    2: {
                        name: "Clinique - Ombré Drama",
                        image: "https://nftcdn.daz3d.com/nfp/upgrades/clinique/2.png",
                        thumb: "https://nftcdn.daz3d.com/nfp/upgrades/clinique/2.png",
                    },
                    3: {
                        name: "Clinique - Bold Cat-Eye",
                        image: "https://nftcdn.daz3d.com/nfp/upgrades/clinique/3.png",
                        thumb: "https://nftcdn.daz3d.com/nfp/upgrades/clinique/3.png",
                    },
                    4: {
                        name: "Clinique - Violet Vibes",
                        image: "https://nftcdn.daz3d.com/nfp/upgrades/clinique/4.png",
                        thumb: "https://nftcdn.daz3d.com/nfp/upgrades/clinique/4.png",
                    },
                    5: {
                        name: "Clinique - Dual Tones",
                        image: "https://nftcdn.daz3d.com/nfp/upgrades/clinique/5.png",
                        thumb: "https://nftcdn.daz3d.com/nfp/upgrades/clinique/5.png",
                    },
                    6: {
                        name: "Clinique - Wired for Love",
                        image: "https://nftcdn.daz3d.com/nfp/upgrades/clinique/6.png",
                        thumb: "https://nftcdn.daz3d.com/nfp/upgrades/clinique/6.png",
                    }
                },
                init: false,
            },
            "0x70a8daec9a6f5c50dc4750a9b7923681d1e01a63": {
                name: "Bakeup",
                tokens: {
                    1: {
                        name: "Bakeup - Disco Veiler",
                        image: "https://nftcdn.daz3d.com/nfp/upgrades/bakeup/veil_original.jpg",
                        thumb: "https://nftcdn.daz3d.com/nfp/upgrades/bakeup/veil_original.jpg",
                    },
                    2: {
                        name: "Clinique - Disco Veiler Rainbow",
                        image: "https://nftcdn.daz3d.com/nfp/upgrades/bakeup/veil_rainbow.jpg",
                        thumb: "https://nftcdn.daz3d.com/nfp/upgrades/bakeup/veil_rainbow.jpg",
                    }
                },
                init: false,
            }
        }
    },
    proxies: {
        list: {
            "0x9b7ce32900e3857bfaac4cd64c584a1f33b1b027": {
                name: "Daz Generic Upgrade",
                contractName: 'UpgradeProxy1155',
                type: 1155,
                types: { '0x92133e21fff525b16d1edcf78be82297d25d1154' : [1,2] }

            },
            "0x1f1062b11c118d84c835f9e117c44456d38c6d58" : {
                name: "Champion x NFP",
                contractName: 'UpgradeProxy721',
                type: 721,
                types: { '0x92133e21fff525b16d1edcf78be82297d25d1154' : [1,2,3] },
                tokenTypes: [1,1,1,1,1,2,1,1,1,1,2,1,3,3,1,1,1,2,1,2,1,1,2,1,1,1,1,3,1,1,1,1,1,3,1,3,1,2,1,1,3,2,1,1,1,1,1,1,1,1,1,1,1,2,3,2,3,1,1,1,1,1,2,3,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,3,1,1,1,1,2,1,1,1,1,2,3,1,1,3,1,1,1,1,3,1,1,2,3,1,1,1,3,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,2,3,1,3,1,1,1,1,1,2,1,1,1,2,1,2,1,3,1,1,1,1,2,3,1,3,2,1,1,1,1,1,1,1,3,1,3,3,1,3,1,1,1,1,3,1,2,2,1,1,1,3,1,1,1,1,1,1,1,2,1,1,3,1,2,1,2,1,3,1,1,1,1,2,2,1,1,2,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,3,1,2,1,1,1,2,1,1,3,3,1,3,2,1,1,1,1,1,1,1,3,1,1,1,2,1,1,2,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,2,3,1,1,3,2,2,1,1,1,1,1,1,2,1,2,1,2,1,3,1,1,2,2,1,1,3,1,1,1,1,1,1,2,3,1,1,1,1,2,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,3,1,3,1,1,1,1,1,3,1,1,1,1,1,1,1,3,1,3,1,1,1,1,3,1,1,1,3,1,3,1,1,1,2,1,1,2,1,3,1,1,2,1,1,1,1,2,1,1,1,3,1,1,1,1,1,1,3,1,3,1,1,1,1,1,1,1,1,3,1,1,1,1,2,1,1,1,1,1,1,3,1,1,1,2,2,1,1,1,2,1,1,1,1,1,1,2,1,2,1,1,1,2,1,2,1,1,2,1,1,3,1,1,1,1,1,1,1,3,1,1,1,1,1,1,1,1,2,2,2,1,2,1,3,1,2,1,1,1,1,1,2,1,3,2,1,1,1,1,1,1,1,1,1,2,3,1,1,1,1,1,1,1,1,2,1,1,1,1,1,2,3,1,1,1,1,1,1,2,1,1,1,1,3,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,2,1,2,3,1,1,1,1,2,1,1,1,1,2,1,3,1,1,1,1,1,1,1,1,1,2,1,1,1,3,1,1,3,1,1,1,1,1,1,1,1,2,1,3,1,2,1,2,1,1,2,1,1,2,1,1,2,1,1,1,1,1,1,1,1,1,1,1,1,1,3,1,1,2,1,1,1,2,1,1,1,1,3,1,2,2,1,1,1,1,1,1,1,3,1,1,1,3,3,1,1,1,2,1,3,1,1,3,1,2,1,1,1,1,1,1,1,2,1,1,1,1,1,1,1,1,1,1,1,2,1,1,1,3,1,1,1,2,1,1,1,1,1,1,1,1,1,3,1,1,3,1,1,1,1,1,2,1,1,1,2,1,1,1,1,1,1,1,1,2,1,1,1,1,2,1,1,2,1,1,1,2,1,1,1,1,1,1,1,1,2,3,1,1,1,1,1,1,1,1,1,1,1,1,3,1,1,1,2,1,1,1,3,1,2,1,1,1,1,1,1,1,2,1,2,2,1,1,1,2,1,1,2,1,1,1,2,1,1,2,3,1,1,1,1,1,1,2,1,3,1,2,2,2,1,1,1,1,1,2,1,1,1,1,1,1,1,2,2,1,1,1,1,1,1,1,1,1,1,3,1,2,1,1,1,1,2,1,1,1,1,1,1,1,1,1,2,1,1,1,1,3,1,1,1,1,1,1,1,3,1,1,1,1,1,1,1,3,2,1,2,1,1,1,1,2,1,1,2,1,1,1,1,1,1,1,1,2,3,1,1,1,1,1,3,3,1,1,1,1,3,1,3,1,1,2,1],
            },
            "0x89ffce6d621dfb9401f8e853522d5beab8346108" : {
                name: "Clinique",
                contractName: 'UpgradeProxy1155',
                type: 1155,
                types: { '0x92133e21fff525b16d1edcf78be82297d25d1154' : [1,2,3,4,5,6] }
            },
            "0x02d103bede9cac973c51fac79c44e18993490cd9" : {
                name: "Bakeup",
                contractName: 'UpgradeProxy1155',
                type: 1155,
                types: { '0x92133e21fff525b16d1edcf78be82297d25d1154' : [1,2] }
            }
        }
    },
    modules: [
        {
            module: NfpUpgradeModule,
            enabled: true
        },
        {
            module: NfpPersonalizationModule,
            enabled: false
        },
        {
            module: Nfp3dModelModule,
            enabled: true
        },
        {
            module: NfpImageModule,
            enabled: true
        },
        {
            module: NfpNetworkModule,
            enabled: true
        }
    ]
}
